<template>
  <div class="block-input" :style="containerStyle" @click="$emit('click')">
    <Icon v-if="icon" :type="icon" class="block-icon" :style="iconStyle"></Icon>
    <div class="block-input-content"
      :style="contentStyle"
    ><slot></slot></div>
  </div>
</template>

<script>
import { Icon } from '../icon'
export default {
  components: { Icon },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconFloat: {
      type: String,
      default: 'left'
    },
    height: {
      type: String,
      default: '47px'
    },
    width: {
      type: String,
      default: ''
    }
  },
  computed: {
    containerStyle () {
      let style = ''
      if (this.height) {
        style += `height:${this.height}`
      }
      if (this.width) {
        style += `;width:${this.width}`
      }
      return style
    },
    iconStyle () {
      let s = ''
      if (this.iconFloat === 'right') {
        s += `right:0`
      }
      return s
    },
    contentStyle () {
      let style = ''
      let left = 14
      let right = 14
      if (this.icon) {
        switch (this.iconFloat) {
          case 'right':
            right += 37
            break
          default:
          case 'left':
            left += 37
        }
      }
      if (this.unit) {
        right += 37
      }
      style += `padding-left: ${left}px; padding-right: ${right}px;`
      return style
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.block-input {
  display: inline-block;
  position: relative;

  & .block-input-content {
    border: none;
    vertical-align: top;

    width: 100%;
    height: 100%;
    border-color: var(--colorDisabled);
    border-width: 1px;
    border-style: solid;
    border-radius: var(--borderRadius3);
    box-sizing: border-box;
    outline: none;

    text-indent: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  & .block-icon {
    position: absolute;
    top: 0;
    height: 100%;
    min-width: 56px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/block/InputBlock.vue